import { v4 as uuidv4 } from 'uuid';

function customRandomValues(buffer: Uint8Array) {
    for (let i = 0; i < buffer.length; i++) {
        buffer[i] = Math.floor(Math.random() * 256);
    }
    return buffer;
}

export const uuidGenerator = {
    generate: (): string => {
        return uuidv4({ random: customRandomValues(new Uint8Array(16)) });
    },
};
